export const css = {
    root: '_3AVV7j8Z',
    title: '_2Tuw28-M',
    status: '_14p3lYr0',
    ' _key': 'book-widgets/topichead'
};
export default css;
